export default {
	GET_ALL: (crewId) => `/houseTask/all?crewId=${crewId}`,
	GET_CONTRIBUTIONS: (crewId) => `/houseTask/contribution/crew?crewId=${crewId}`,
	GET_ALL_CONTRIBUTIONS: (crewId) => `/houseTask/contribution/all?crewId=${crewId}`,
	CREATE: (crewId) => `/houseTask?crewId=${crewId}`,
	UPDATE: (id) => `/houseTask/${id}`,
	UPDATE_COMPLETE: (id) => `/houseTask/${id}/complete`,
	UPDATE_CONTRIBUTION: (id) => `/houseTask/contribution/${id}`,
	DELETE: (id) => `/houseTask/${id}`,
	DELETE_CONTRIBUTION: (id) => `/houseTask/contribution/${id}`,
};
